import React from "react";
import { LinkContainer } from "react-router-bootstrap";
import locale from "locale";
import { Breadcrumb, Row } from "react-bootstrap";

const Breadcrumbs = ({
    link,
    activeCrumbs,
    linkLabel = locale("email.broadcast"),
}) => {
    return (
        <Row>
            <Breadcrumb>
                <LinkContainer to={link}>
                    <Breadcrumb.Item>{linkLabel}</Breadcrumb.Item>
                </LinkContainer>
                {activeCrumbs.map((crumb, index) => (
                    <Breadcrumb.Item key={crumb + index} active>
                        {locale(crumb) || crumb}
                    </Breadcrumb.Item>
                ))}
            </Breadcrumb>
        </Row>
    );
};

export default Breadcrumbs;
